// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available application actions
export const APPLICATION_ACTIONS_KEY = {
  SET_APPLICATION_THEME: 'SET_APPLICATION_THEME',
  SET_APPLICATION_STATUS: 'SET_APPLICATION_STATUS',
  GET_ALL_INITIAL_DATA: 'GET_ALL_INITIAL_DATA',
  SET_PERMISSIONS_MAPPING: 'SET_PERMISSIONS_MAPPING',
  SET_APPLICATION_ERROR_MESSAGE: 'SET_APPLICATION_ERROR_MESSAGE',
  CLEAR_APPLICATION_ERROR_MESSAGE: 'CLEAR_APPLICATION_ERROR_MESSAGE',
};
